/* eslint-disable no-bitwise */
/* eslint-disable import/no-unused-modules */
import { workspaceColorsMap } from '@carboncopyco/types';
import {
  type GlobalTabType,
  type IGlobalTab,
  type InterceptorStateKeys,
  TabType,
} from '@carboncopyco/types/desktop';

const ipcRenderer = window?.dsDesktop?.ipcRenderer;

const isURL = (input: string): boolean => {
  const pattern = /^(?:\w+:)?\/\/([^\s.]+\.\S{2}|localhost[:?\d]*)\S*$/;
  return pattern.test(input) ? true : pattern.test(`https://${input}`);
};

const updateDontShowThisAgain = (value: any, key: string) => {
  const mode = 'record';
  const dontShowAgainList = JSON.parse(<string>localStorage.getItem(key)) || [];

  localStorage.setItem(
    key,
    JSON.stringify(
      value
        ? [...dontShowAgainList, mode]
        : dontShowAgainList.filter((item: string) => item !== mode)
    )
  );
};

const openLinkInBrowser = (e: any, link: string) => {
  if (e) {
    e.preventDefault();
  }

  if (ipcRenderer) {
    window.dsDesktop.shellOpenExternal(link);
  }
};

const isOnline = async () => {
  const onlineStatus = await window?.dsDesktop?.app?.isOnlineCheck();
  if (!onlineStatus) {
    throw new Error('No internet connection');
  }
  return onlineStatus;
};

export const debuggerInterceptorState = {
  setItem: (key: InterceptorStateKeys, val: any[]) => {
    window.dsDesktop.interceptorState.setItem(key, val);
  },

  removeItem: (key: InterceptorStateKeys) => {
    window.dsDesktop.interceptorState.removeItem(key);
  },

  getItem: async (key: InterceptorStateKeys) =>
    window.dsDesktop.interceptorState.getItem(key),
  clearStateForKeys: (keys: InterceptorStateKeys[]) => {
    window.dsDesktop.interceptorState.clearStateForKeys(keys);
  },
};

export const shouldUseDraftPlayerToken = (tab: IGlobalTab) =>
  tab.type === TabType.DEMO_EDITOR ||
  tab.type === TabType.OVERLAY_EDITOR ||
  tab.type === TabType.MOBILE_DEMO_EDITOR;

export const isHandledInComponent = (tab: IGlobalTab) =>
  [
    TabType.PREVIEW_DEMO,
    TabType.PREVIEW_OVERLAY,
    TabType.PRESENT_DEMO,
    TabType.TOURS_CREATE,
    TabType.GROUP_DEMO_PRESENTATION,
    TabType.GROUP_DEMO_PREVIEW,
  ].includes(tab.type) ||
  ('createGlobalTabOnElectron' in tab &&
    (tab as IGlobalTab & GlobalTabType).createGlobalTabOnElectron?.startOn ===
      'component-load') ||
  shouldUseDraftPlayerToken(tab);

const colors = Object.keys(workspaceColorsMap);

export const assignColor = (initials: string): string => {
  if (initials.trim() === '') return 'bg-ds-accent2-400';
  const sum = [...initials].reduce(
    (total, char) => total + char.charCodeAt(0),
    0
  );
  const index = sum % colors.length;
  return colors[index];
};

export {
  ipcRenderer,
  isURL,
  updateDontShowThisAgain,
  openLinkInBrowser,
  isOnline,
};

export const isActiveOrAllInnerTabsLoaded = (globalTab: IGlobalTab) => {
  const allInnerTabsLoaded = globalTab?.innerTabs?.every(
    (tab) => tab.isInnerViewLoaded
  );
  const activeInnerTab = globalTab?.innerTabs?.find(
    (tab) => globalTab.activeInnerTabId === tab.id
  );
  return Boolean(allInnerTabsLoaded || activeInnerTab?.isInnerViewLoaded);
};
